module.exports = __webpack_public_path__ + "img/121.307b8edc.gif";